export default __webpack_public_path__ + "static/media/Rustic Fauld.7bffccc9.jpg";